var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.25,
    height: 20.842,
    viewBox: "0 0 17.25 20.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Alert_Icon_-_Inactive",
    "data-name": "Alert Icon - Inactive",
    d: "M9.858,1.3V2.03a6.1,6.1,0,0,1,4.929,6.111V9.5a8.468,8.468,0,0,0,1.686,5.089l.574.757a1.021,1.021,0,0,1,.112,1.034.922.922,0,0,1-.832.553H.924a.922.922,0,0,1-.833-.553A1.023,1.023,0,0,1,.2,15.347l.574-.757A8.457,8.457,0,0,0,2.465,9.5V8.141A6.1,6.1,0,0,1,7.393,2.03V1.3a1.234,1.234,0,1,1,2.465,0M8.318,3.908a4.125,4.125,0,0,0-4,4.233V9.5A10.535,10.535,0,0,1,2.785,14.98H14.467A10.536,10.536,0,0,1,12.938,9.5V8.141a4.125,4.125,0,0,0-4-4.233ZM11.09,18.237a2.752,2.752,0,0,1-.72,1.844,2.455,2.455,0,0,1-1.744.761,2.4,2.4,0,0,1-1.745-.761,2.752,2.752,0,0,1-.72-1.844Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.7a15a1553fbf3dffe74604bf051ac6bc.svg";
export { ForwardRef as ReactComponent };